import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import themeStyles from './DealerContact.style';
import DealerContactDetail from './DealerContactDetail';

const ContactContainer = themeStyles.apply(Box, 'ContactContainer');

const DealerContact = ({ children }) => <ContactContainer>{children}</ContactContainer>;

DealerContact.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export { DealerContactDetail };
export default DealerContact;
